import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { MainFirmContact } from '../types';

type MainFirmContactResponse = {
  success: boolean;
  message: string;
  data: Array<MainFirmContact>;
};

type Return = Array<MainFirmContact>;

export type GetMainFirmContacts = {
  response: MainFirmContactResponse;
  return: Return;
};

export const getMainFirmContacts = withLogger(async (): Promise<Return> => {
  const url = globalLetterAPIUrls.mainFirmContacts;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<MainFirmContactResponse>(url);

  return data;
});
